'use client';

import React from 'react';
import { useTranslations } from 'next-intl';

export default function ComplianceStatement() {
  // 使用 'compliance' 命名空间加载翻译
  const t = useTranslations('compliance');
  const tCommon = useTranslations('common');
  
  // 如果无法加载翻译，显示加载中
  if (!t) {
    return <div>{tCommon('loading')}</div>;
  }
  
  // 直接使用 t() 访问嵌套的翻译键
  // 不需要创建 compliance 对象，直接使用 t() 访问每个键
  
  return (
    <section className="max-w-4xl mx-auto py-8 px-4">
      <h1 className="text-3xl font-bold mb-6">{t('title')}</h1>
      <p className="mb-4">{t('globalCommitment')}</p>
      <p className="mb-4">{t('intro')}</p>
      
      <ul className="list-disc pl-6 mb-6 space-y-2">
        <li>{t('gdpr')}</li>
        <li>{t('uk_gdpr')}</li>
        <li>{t('ccpa')}</li>
        <li>{t('pipeda')}</li>
        <li>{t('appi')}</li>
        <li>{t('pipa')}</li>
        <li>{t('fz152')}</li>
        <li>{t('lgpd')}</li>
        <li>{t('lfpdppp')}</li>
        <li>{t('pipl')}</li>
        <li>{t('pdpa')}</li>
      </ul>
      
      <p className="mb-6">{t('dynamic')}</p>
      
      <h2 className="text-2xl font-semibold mb-4">{t('rightsTitle')}</h2>
      <ul className="list-disc pl-6 mb-6 space-y-2">
        <li>{t('right1')}</li>
        <li>{t('right2')}</li>
      </ul>
      
      <h2 className="text-2xl font-semibold mb-4">{t('localizationTitle')}</h2>
      <ul className="list-disc pl-6 mb-6 space-y-2">
        <li>{t('localization1')}</li>
        <li>{t('localization2')}</li>
      </ul>
      
      <h2 className="text-2xl font-semibold mb-4">{t('contactTitle')}</h2>
      <p className="mb-6">{t('contact1')}</p>
      
      <footer className="mt-8 pt-4 border-t border-border">
        <p className="text-sm text-muted-foreground">{t('footer')}</p>
      </footer>
    </section>
  );
}
